import React, { useState } from "react";

const Training = () => {
  const [videoUnavailable, setVideoUnavailable] = useState(false);

  return (
    <div className="training-page">
      <style>{`
        .training-page,
        .training-page * {
          box-sizing: border-box;
        }

        .training-page {
          min-height: 100vh;
          position: relative;
          overflow-x: hidden;
          color: #eaf6ff;
          font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
          background:
            radial-gradient(circle at 16% 12%, rgba(0, 221, 255, 0.16), transparent 28%),
            radial-gradient(circle at 86% 18%, rgba(212, 160, 23, 0.12), transparent 26%),
            linear-gradient(145deg, #061014 0%, #0a151b 48%, #050609 100%);
          isolation: isolate;
        }

        .training-page::before,
        .training-page::after {
          content: "";
          position: fixed;
          inset: 0;
          pointer-events: none;
          z-index: -1;
        }

        .training-page::before {
          opacity: 0.26;
          background-image:
            linear-gradient(rgba(75, 224, 255, 0.09) 1px, transparent 1px),
            linear-gradient(90deg, rgba(75, 224, 255, 0.09) 1px, transparent 1px);
          background-size: 44px 44px;
          mask-image: linear-gradient(to bottom, rgba(0,0,0,0.94), rgba(0,0,0,0.18));
          animation: training-grid-drift 18s linear infinite;
        }

        .training-page::after {
          opacity: 0.16;
          background:
            linear-gradient(180deg, transparent 0%, rgba(0, 221, 255, 0.12) 48%, transparent 52%),
            radial-gradient(circle at 72% 76%, rgba(0, 221, 255, 0.18), transparent 24%);
          background-size: 100% 280px, 100% 100%;
          animation: training-scan 8s ease-in-out infinite;
        }

        .training-shell {
          width: 100%;
          max-width: 1260px;
          min-height: calc(100vh - 48px);
          margin: 0 auto;
          padding: clamp(20px, 4vw, 48px);
          display: grid;
          align-items: center;
        }

        .training-hero {
          position: relative;
          overflow: hidden;
          display: grid;
          grid-template-columns: minmax(0, 0.92fr) minmax(320px, 1.08fr);
          gap: clamp(24px, 4vw, 48px);
          align-items: center;
          border: 1px solid rgba(75, 224, 255, 0.24);
          border-radius: 24px;
          padding: clamp(24px, 4.2vw, 52px);
          background:
            linear-gradient(135deg, rgba(10, 27, 34, 0.93), rgba(8, 14, 20, 0.72)),
            radial-gradient(circle at 82% 18%, rgba(212, 160, 23, 0.15), transparent 28%);
          box-shadow:
            0 28px 86px rgba(0, 0, 0, 0.4),
            inset 0 1px 0 rgba(255, 255, 255, 0.08),
            0 0 36px rgba(0, 221, 255, 0.08);
          animation: training-page-in 560ms ease both;
        }

        .training-hero::before {
          content: "";
          position: absolute;
          inset: -42%;
          background: conic-gradient(from 120deg, transparent, rgba(0, 221, 255, 0.16), transparent, rgba(212, 160, 23, 0.14), transparent);
          opacity: 0.4;
          animation: training-mesh 14s linear infinite;
        }

        .training-hero::after {
          content: "";
          position: absolute;
          inset: 0;
          border-radius: inherit;
          padding: 1px;
          background: linear-gradient(120deg, transparent, rgba(75, 224, 255, 0.46), transparent, rgba(212, 160, 23, 0.3), transparent);
          -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
          -webkit-mask-composite: xor;
          mask-composite: exclude;
          opacity: 0.8;
          pointer-events: none;
        }

        .training-copy,
        .training-video-panel {
          position: relative;
          z-index: 1;
        }

        .training-kicker {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 16px;
          color: #d4a017;
          font-size: 0.72rem;
          font-weight: 800;
          letter-spacing: 0.2em;
          text-transform: uppercase;
        }

        .training-kicker span,
        .training-badge span {
          width: 9px;
          height: 9px;
          border-radius: 999px;
          background: #34f6a5;
          box-shadow: 0 0 16px rgba(52, 246, 165, 0.78);
          animation: training-pulse 1.8s ease-in-out infinite;
        }

        .training-copy h1 {
          margin: 0;
          color: #f8fbff;
          font-size: clamp(2.6rem, 6vw, 5.4rem);
          line-height: 0.9;
          letter-spacing: 0.04em;
          text-transform: uppercase;
          text-shadow: 0 0 34px rgba(0, 221, 255, 0.24);
        }

        .training-badge {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          margin: 24px 0 18px;
          border: 1px solid rgba(75, 224, 255, 0.2);
          border-radius: 999px;
          padding: 10px 14px;
          background: rgba(5, 18, 24, 0.66);
          color: #eaf8ff;
          font-size: 0.82rem;
          font-weight: 900;
          letter-spacing: 0.16em;
          text-transform: uppercase;
          box-shadow: 0 0 26px rgba(0, 221, 255, 0.1), inset 0 0 16px rgba(0, 221, 255, 0.05);
          animation: training-badge-glow 2.8s ease-in-out infinite;
        }

        .training-copy p {
          max-width: 620px;
          margin: 0 0 28px;
          color: rgba(224, 239, 255, 0.74);
          font-size: clamp(0.92rem, 1.35vw, 1.05rem);
          line-height: 1.72;
        }

        .training-disabled-button {
          position: relative;
          overflow: hidden;
          min-height: 50px;
          border: 1px solid rgba(212, 160, 23, 0.48);
          border-radius: 14px;
          padding: 0 20px;
          background: linear-gradient(135deg, rgba(212, 160, 23, 0.88), rgba(242, 198, 79, 0.78));
          color: #081014;
          cursor: not-allowed;
          font: inherit;
          font-size: 0.78rem;
          font-weight: 900;
          letter-spacing: 0.13em;
          text-transform: uppercase;
          box-shadow: 0 18px 42px rgba(212, 160, 23, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.24);
          opacity: 0.82;
        }

        .training-video-panel {
          min-width: 0;
        }

        .training-video-frame {
          position: relative;
          overflow: hidden;
          aspect-ratio: 16 / 10;
          border: 1px solid rgba(75, 224, 255, 0.22);
          border-radius: 22px;
          background:
            radial-gradient(circle at 50% 48%, rgba(0, 221, 255, 0.18), transparent 30%),
            linear-gradient(rgba(75, 224, 255, 0.09) 1px, transparent 1px),
            linear-gradient(90deg, rgba(75, 224, 255, 0.09) 1px, transparent 1px),
            rgba(3, 12, 16, 0.8);
          background-size: 100% 100%, 28px 28px, 28px 28px, 100% 100%;
          box-shadow: 0 24px 68px rgba(0, 0, 0, 0.34), inset 0 1px 0 rgba(255, 255, 255, 0.08);
        }

        .training-video-frame video {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          opacity: 0.82;
          filter: saturate(1.08) contrast(1.08);
        }

        .training-video-frame::after {
          content: "";
          position: absolute;
          inset: 0;
          pointer-events: none;
          background: linear-gradient(180deg, transparent, rgba(0, 0, 0, 0.18)), radial-gradient(circle at 50% 50%, transparent 36%, rgba(0, 0, 0, 0.22));
        }

        .training-placeholder {
          position: absolute;
          inset: 0;
          display: grid;
          place-items: center;
          text-align: center;
          padding: 28px;
        }

        .training-orbit {
          position: relative;
          width: min(42vw, 210px);
          aspect-ratio: 1;
          border: 1px solid rgba(75, 224, 255, 0.34);
          border-radius: 999px;
          box-shadow: 0 0 44px rgba(0, 221, 255, 0.16), inset 0 0 34px rgba(0, 221, 255, 0.08);
          animation: training-orbit 5s linear infinite;
        }

        .training-orbit::before,
        .training-orbit::after {
          content: "";
          position: absolute;
          border-radius: 999px;
        }

        .training-orbit::before {
          inset: 18%;
          border: 1px solid rgba(212, 160, 23, 0.34);
        }

        .training-orbit::after {
          width: 14px;
          height: 14px;
          right: 13%;
          top: 18%;
          background: #00ddff;
          box-shadow: 0 0 22px rgba(0, 221, 255, 0.78);
        }

        .training-placeholder strong {
          position: absolute;
          color: rgba(234, 248, 255, 0.78);
          font-size: 0.8rem;
          letter-spacing: 0.16em;
          text-transform: uppercase;
        }

        @keyframes training-page-in {
          from { opacity: 0; transform: translateY(16px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes training-grid-drift {
          from { background-position: 0 0; }
          to { background-position: 44px 44px; }
        }

        @keyframes training-scan {
          0%, 100% { background-position: 0 -280px, 0 0; }
          50% { background-position: 0 100vh, 0 0; }
        }

        @keyframes training-mesh {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        @keyframes training-pulse {
          0%, 100% { opacity: 0.72; transform: scale(1); }
          50% { opacity: 1; transform: scale(1.16); }
        }

        @keyframes training-badge-glow {
          0%, 100% { box-shadow: 0 0 18px rgba(0, 221, 255, 0.1), inset 0 0 16px rgba(0, 221, 255, 0.05); }
          50% { box-shadow: 0 0 34px rgba(0, 221, 255, 0.22), inset 0 0 20px rgba(0, 221, 255, 0.08); }
        }

        @keyframes training-orbit {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        @media (max-width: 900px) {
          .training-shell {
            align-items: start;
          }

          .training-hero {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 520px) {
          .training-shell {
            padding: 18px 14px 28px;
          }

          .training-hero {
            border-radius: 18px;
            padding: 22px 16px;
          }

          .training-disabled-button {
            width: 100%;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .training-page::before,
          .training-page::after,
          .training-hero,
          .training-hero::before,
          .training-kicker span,
          .training-badge,
          .training-badge span,
          .training-orbit {
            animation: none !important;
          }
        }
      `}</style>

      <main className="training-shell">
        <section className="training-hero" aria-labelledby="training-title">
          <div className="training-copy">
            <div className="training-kicker">
              <span />
              Training Center
            </div>
            <h1 id="training-title">Training Center</h1>
            <div className="training-badge">
              <span />
              Coming Soon
            </div>
            <p>
              Advanced agent training modules, onboarding videos, compliance
              walkthroughs, and carrier education resources are being prepared.
            </p>
            <button className="training-disabled-button" type="button" disabled>
              Training Modules Launching Soon
            </button>
          </div>

          <div className="training-video-panel">
            <div className="training-video-frame">
              {!videoUnavailable && (
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  onError={() => setVideoUnavailable(true)}
                >
                  <source src="/training/training-preview.mp4" type="video/mp4" />
                </video>
              )}
              {videoUnavailable && (
                <div className="training-placeholder" aria-label="Training preview unavailable">
                  <div className="training-orbit" />
                  <strong>Preview Initializing</strong>
                </div>
              )}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Training;
